export enum TableColumnTypes {
  METRIC = "metric",
  FORMULA = "formula",
  COMPARE = "compare",
}
